import {BaseLayerDeck} from './baseLayerDeck';
import {groupBy} from '../utils';


export abstract class BaseLayerMVTDeck extends BaseLayerDeck {
    protected constructor(id) {
        super(id);
    }


    init(map, visible, underLayerId = null, loadedCallback: (layer) => void) {
        map.addToLoading(this);
        this.getDataLayer().then((layers) => {
            layers.forEach(l => {
                const layer = this.layers[l.id];
                this.setLayerFilters();
                const _data = {data: l.tiles.features};
                this.layers[l.id] = layer.clone(_data);
            });
            super.init(map, visible, underLayerId, loadedCallback);
            map.removeFromLoading();
        });
    }

    abstract setLayerFilters();

    abstract getDataLayer();

    countViewportFeatures(city, layer_id, allowed = [], variable = 'types', _groupBy = 'layer') {
        const groupedByLayer = groupBy(
            this.getViewportFeatures(layer_id),
            _groupBy
        );
        city[variable].forEach(v => {
            if (allowed.includes(v.idText)) {
                if (!v.showing) {
                    v.data = [];
                }
            }
        });
        if (Object.keys(groupedByLayer).length) {
            for (const group of Object.keys(groupedByLayer)) {
                const groupType = city[variable].find(v => v.idText === group && v.showing);
                if (groupType) {
                    groupType.data = groupedByLayer[group];
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/common/layers/baseLayerMVTDeck.ts